export default "__VITE_ASSET__B4YeN4mI__"